export const mockCurrencyData: string[] = ['GBP', 'USD', 'JPY', 'EUR', 'CAD'];
